import { generateArrayOfNumbers } from "../../../../../../shared";
import { StatsLoaderProps } from "../types";
import RectangularSkeleton from "./RectangularSkeleton";

const StatsLoader = ({ count }: StatsLoaderProps) => {
    const arrayOfNumbers = generateArrayOfNumbers(count);

    return (
        <div>
            {arrayOfNumbers.map(item => (
                <RectangularSkeleton key={item} />
            ))}
        </div>
    );
};

export default StatsLoader;
